/* ⚛ REACT */
import { useState } from "react";

/* 📦 LIBS */
import { useTour } from "@reactour/tour";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

/* 🧩 COMPONENTS */
import { CustomLoading } from "../../../../Components";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 📁 ASSETS*/
import { Fixar, Fixado, Atualizar, ChangeIcon, Advertencia, Manutencao, PerdaComunicacao, Critico } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, ContentContainer, InfoNumber, InfoContainer, Description,
    CardPlaceHolderContainer, SvgIcon, ChangeIconSVG, ChangeIconContainer, FavIconContainer, 
    FavButton, AlertContainer, AlertIcon, ContainerFavButtonMobile } from "./styles";

/* 🔧 UTILS */
import { GetCardsColor } from "../../../../util/Colors";


const CardBig = ({index, id = [], Bar, Title, Color, Active, Focus, hasMore, valor, porcentagem, unidade, descricao, onClick, PutCard, isLoading, isfav, removeFAV, notFixed = false}) => {

    const statusIconMap = {
        1: Advertencia,
        2: Critico,
        3: PerdaComunicacao,
        4: Manutencao,
    };
    
    const background = GetCardsColor(Color, Focus);
    const { t } = useTranslation();
    const { currentStep } = useTour();

    const updateCardIcon = useSelector(state => state.DashboardEquipamentoReducer.updateCardIcon);
    
    const [hovered, setHovered] = useState(false);

    
    const iconSrc = statusIconMap[background.status];
    const iconColor = Focus ? background.background : '#FFF';

    const handlePin = (event) => {
        event.stopPropagation();
        onClick();
    }

    const handleUnpin = (event) => {
        event.stopPropagation();
        removeFAV();
    }

    const handleChangeCard = (event) => {
        event.stopPropagation();
        PutCard(index);
    }


    
    if(Active && !isLoading){
        return (
            <Container 
                id={`${id?.[0]}`}
                color={background.background}
                $isfocus={Focus} 
                $isfav={isfav} 
                $notFixed={notFixed}
                onMouseEnter={() => !updateCardIcon && setHovered(true)} 
                onMouseLeave={() => !updateCardIcon && setHovered(false)}
                onClick={(e) => notFixed? handlePin(e) : isfav && onClick()}
            >   
                {notFixed===false && (
                    <>
                        {(hovered || (currentStep === 10 || currentStep === 11 || currentStep === 13) || (updateCardIcon && isfav)) && (
                            <FavButton id={`${id?.[3] + index}`} onClick={(e) => (updateCardIcon && isfav ? handleChangeCard(e) : isfav ? handleUnpin(e) : handlePin(e))}>
                                <FavIconContainer id={`${id?.[1]}`} src={(updateCardIcon && isfav) || (isfav && currentStep === 13) ? Atualizar : isfav ? Fixado : Fixar} />
                            </FavButton>
                        )}

                        <ContainerFavButtonMobile>
                            <FavButton id={`${id?.[3] + index}`} onClick={(e) => (updateCardIcon && isfav ? handleChangeCard(e) : isfav ? handleUnpin(e) : handlePin(e))}>
                                <FavIconContainer id={`${id?.[1]}`} src={(updateCardIcon && isfav) || (isfav && currentStep === 13) ? Atualizar : isfav ? Fixado : Fixar} />
                            </FavButton>
                        </ContainerFavButtonMobile>
                    </>
               )}

            <AlertContainer>
                {iconSrc && <AlertIcon src={iconSrc} color={iconColor} />}
            </AlertContainer>

                <TitleContainer $isfocus={Focus}>{Title}</TitleContainer>
                
                <ContentContainer $isfocus={Focus} $notFixed={notFixed}>
                    {porcentagem || porcentagem === 0 ? Bar : null}
                    <InfoContainer>
                        <InfoNumber $isfocus={Focus}> {valor} </InfoNumber>
                        <Description $isfocus={Focus}> {unidade} </Description>
                        {
                            porcentagem || porcentagem === 0 ? 
                            <>
                                <InfoNumber $isfocus={Focus}> {porcentagem}% </InfoNumber>
                                <Description $isfocus={Focus}> {descricao} </Description>
                            </>
                            : null
                        }
                    </InfoContainer>
                </ContentContainer>
                {!Focus && hasMore ?
                    <ChangeIconContainer 
                        color={background.background}
                        // onMouseEnter={()=>setHovered(true)}
                        onClick={(e) => {
                            e.stopPropagation()
                            PutCard(index)
                    }}>
                        <ChangeIconSVG src={ChangeIcon}/>
                        {t("dashboards.big-card.change-card")}
                    </ChangeIconContainer>
                :<></>}
            </Container>
           
        );
    }else{
            <CardPlaceHolderContainer
                id={id?.[2]}
                $isfav={isfav}
                $isfocus={Focus}
                disabled={isLoading}
                color={hasMore ? '#006560' : '#A3A3A3'}
                onClick={() => PutCard(index)}
            >
                {isLoading ? (
                    <CustomLoading width="50px" height="50px" />
                ) : (
                    <>
                        <p>
                            <Trans
                                i18nKey="dashboards.big-card.card-placeholder"
                                components={{ br: <br /> }}
                            />
                        </p>
                        <SvgIcon src={Fixar} />
                    </>
                )}
            </CardPlaceHolderContainer>
     }
}

export default CardBig;
